import { render, staticRenderFns } from "./LobbyScreen.vue?vue&type=template&id=3b4736b8&scoped=true"
import script from "./LobbyScreen.vue?vue&type=script&lang=js"
export * from "./LobbyScreen.vue?vue&type=script&lang=js"
import style0 from "./LobbyScreen.vue?vue&type=style&index=0&id=3b4736b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4736b8",
  null
  
)

export default component.exports